import { UploadPayload } from "@providers/hop-ord-server/api";
import axios from "axios";

export const uploadToS3 = async ({
  payload,
  file,
  setProgress,
  onComplete,
  onError,
  abortController,
}: {
  payload: UploadPayload;
  file: File | null;
  setProgress?: (percentage: number) => void;
  onComplete?: () => void;
  onError?: () => void;
  abortController?: AbortController;
}) => {
  const formData = new FormData();

  // AWS Fields for uploading
  formData.append("key", payload.fields.key);
  formData.append("policy", payload.fields.policy);
  if (payload.fields.signature) {
    formData.append("signature", payload.fields.signature);
  }
  formData.append(
    "x-amz-security-token",
    payload.fields["x-amz-security-token"],
  );
  if (payload.fields.AWSAccessKeyId) {
    formData.append("AWSAccessKeyId", payload.fields.AWSAccessKeyId);
  }
  if (payload.fields["x-amz-credential"]) {
    formData.append("x-amz-credential", payload.fields["x-amz-credential"]);
  }
  if (payload.fields["x-amz-signature"]) {
    formData.append("x-amz-signature", payload.fields["x-amz-signature"]);
  }
  if (payload.fields["x-amz-algorithm"]) {
    formData.append("x-amz-algorithm", payload.fields["x-amz-algorithm"]);
  }
  if (payload.fields["x-amz-date"]) {
    formData.append("x-amz-date", payload.fields["x-amz-date"]);
  }

  formData.append("file", file || "");
  await axios
    .post(payload.url, formData, {
      onUploadProgress: (progressEvent) => {
        const { loaded, total } = progressEvent;
        const percentage = total ? Math.floor((loaded * 100) / total) : 0;
        if (setProgress) {
          setProgress(percentage);
        }
      },
      signal: abortController?.signal,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then(() => {
      if (onComplete) {
        onComplete();
      }
    })
    .catch(() => {
      if (onError) {
        onError();
      }
    });
  return formData;
};
